import { AlarmNameSegment } from '../../../shared/model/alarms/alarm-name-part';

export class SANameGeneratorSettings {
  alarmNameSegments: AlarmNameSegment[];

  constructor(init?: SANameGeneratorSettings) {
    Object.assign(this, init);
  }
}
